<template>
    <div class="mc-spinner-new" :style="'font-size: ' + props.size + 'px'">
        <span class="mc-spinner-new__bubble"></span>
        <span class="mc-spinner-new__bubble --delayed"></span>
        <span class="mc-spinner-new__bubble --more-delayed"></span>
    </div>
</template>

<script setup lang="ts">
export interface Props {
    size?: string
}

const props = withDefaults(defineProps<Props>(), {
    size: "5",
})
</script>

<style lang="sass" scoped>
.mc-spinner-new
    @keyframes jump
        0%, 90%, 100%
            transform: scale(0)

        40%
            transform: scale(1)

        70%
            transform: scale(0.85)

        80%
            transform: scale(1)

    &__bubble
        transform: scale(0)
        display: inline-block
        margin-right: 2em
        width: 8em
        height: 8em
        background-color: $yellow
        border-radius: 100px
        animation: jump 1.7s ease-in infinite

        &.\--delayed
            animation-delay: 0.15s

        &.\--more-delayed
            animation-delay: 0.3s
</style>
